import { Box, Divider, Typography } from '@mui/material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import DetailHeroPanel from '../../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../../shared/components/DetailInfoPanel'
import CardHero from '../../../../../shared/components/frontoffice/CardHero'
import ShareIcon from '../../../../../shared/components/icons/ShareIcon'
import { NoveltyDetailSidebarProps } from '../../../models/novelties'

dayjs.extend(relativeTime)

const NoveltyDetailSidebar = ({
  isAdmin,
  isMobile,
  noveltySelected,
  infoDetail,
  sortNovelties,
  authUser,
  handleToggleForm,
  handleShowNovelty,
  handleFavoriteClick,
  cutContent
}: NoveltyDetailSidebarProps) => {
  const { t } = useTranslation(['global'])

  return isAdmin ? (
    <>
      <DetailHeroPanel
        visibility={noveltySelected.visibility !== null && noveltySelected.visibility}
        brand={noveltySelected?.brand?.name}
        title={noveltySelected.title !== null && noveltySelected.title}
        author={noveltySelected.responsibles?.length > 0 ? noveltySelected.responsibles[0].name : null}
        statusC={
          <>
            {noveltySelected.status === 0 && `${t('active')}`}
            {noveltySelected.status === 1 && `${t('inactive')}`}
            {noveltySelected.status === 2 && `${t('draft')}`}
          </>
        }
        description={noveltySelected.description !== null && noveltySelected.description}
        edit={handleToggleForm}
        share={
          <ShareIcon
            meta={true}
            visibility={noveltySelected.visibility}
            title={noveltySelected.title}
            description={noveltySelected.description || ''}
            link={window.location.href}
            multimedia={noveltySelected.image_url}
            component="buttonTextGreen"
            type="course"
            buttonTextGreen={t('share')}
          />
        }
      />
      {isMobile ? <></> : <DetailInfoPanel attributes={infoDetail} />}
    </>
  ) : (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', pb: 3, mt: 3 }}>
        <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
          {t('more-novelties')}
        </Typography>
        <Divider sx={{ marginLeft: 2, flexShrink: 1 }} />
      </Box>

      {sortNovelties
        .filter((novelty: any) => novelty.visibility === 2)
        .slice(0, 5)
        .map((novelty: any) => (
          <Box key={novelty.id} sx={{ mb: 2 }}>
            <CardHero
              type={1}
              onClickCard={() => handleShowNovelty(novelty.slug)}
              redirect={`/novedades/${novelty.slug}`}
              cardBrandName={novelty.brand?.name || ''}
              cardVisibility={novelty.visibility}
              cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
              cardTitle={novelty.title}
              cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(novelty.content) }} />}
              cardDate={`${dayjs(novelty.created_at).fromNow()}`}
              cardActions={
                <ShareIcon
                  meta={true}
                  visibility={novelty.visibility}
                  title={novelty.title}
                  description={novelty.title}
                  link={`${window.location.origin}/novedades/${novelty.slug}${window.location.search}`}
                  type="novelty"
                  multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${novelty.image_url}`}
                />
              }
              favoriteState={Boolean(novelty.favoriteId)}
              onClickFavorite={authUser === null ? undefined : handleFavoriteClick(novelty.id)}
            />
          </Box>
        ))}
    </>
  )
}

export default NoveltyDetailSidebar
